<template>
    <div class="space-y-12">
        <select-dropdown
            v-model="filterFields.jobTagIds"
            :auto-translate="false"
            multiple
            searchable
            :options="jobTags"
            :placeholder="$t('form.dropdown.placeholder')"
            remove-icon
            can-select-all
            :input-label="$t('general.jobs.title')"
        />
        <select-dropdown
            v-model="filterFields.applicationTagIds"
            :auto-translate="false"
            multiple
            searchable
            :options="applicationTags"
            :placeholder="$t('form.dropdown.placeholder')"
            remove-icon
            can-select-all
            :input-label="$t('general.applications.title')"
        />
    </div>
</template>

<script>
import SelectDropdown from "../forms/SelectDropdown";
import Tag from "../../models/Tag";
import {useRepo} from 'pinia-orm';

export default {
    components: {
        SelectDropdown,
    },
    props: {
        filterFields: {type: Object},
    },
    computed: {
        jobTags() {
            return useRepo(Tag).all().filter(i => i.job_count > 0).map(tag => ({
                value: tag.id,
                label: tag.title,
            }));
        },
        applicationTags() {
            return useRepo(Tag).all().filter(i => i.application_count > 0).map(tag => ({
                value: tag.id,
                label: tag.title,
            }));
        }
    }
}
</script>
